/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Count_OneInputs */



/**
* | output |
* | --- |
* | "1 source" |
*
* @param {Meeting_Sources_Count_OneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_count_one = /** @type {((inputs?: Meeting_Sources_Count_OneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Count_OneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("1 bron")
	if (locale === "fr") return /** @type {LocalizedString} */ ("1 source")
	return /** @type {LocalizedString} */ ("1 source")
});